import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { CURRENCY_ACTION_TYPE } from "./currency.action";
import { Currency, CurrencyState } from "./currency.model";

const initialState: CurrencyState = {};

export function currencyReducer(state = initialState, action: ActionWithPayload): CurrencyState {
	switch (action.type) {
		case CURRENCY_ACTION_TYPE.getAllSuccess: {
			return updateState(state, {
				currencies: action.payload as Currency[],
			});
		}
		default:
			return state;
	}
}
